import { render, staticRenderFns } from "./CoozzySpinner.vue?vue&type=template&id=27f78c68&scoped=true"
import script from "./CoozzySpinner.vue?vue&type=script&lang=js"
export * from "./CoozzySpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f78c68",
  null
  
)

export default component.exports